export enum NationalIdNumberTypes {
  SSN = 1,
  ITIN = 2,
}

export class NationalIdNumberTypeIds {
  public static get SSN(): number {
    return NationalIdNumberTypes.SSN;
  }

  public static get ITIN(): number {
    return NationalIdNumberTypes.ITIN;
  }
}
export interface NationalIdNumberTypeDefinition {
  id: number;
  abbreviation: string;
  name: string;
  errorMessage: string;
}

export const NationalIdNumberTypeDefinitions: Readonly<
  Record<number, NationalIdNumberTypeDefinition>
> = {
  [NationalIdNumberTypeIds.ITIN]: {
    id: NationalIdNumberTypeIds.ITIN,
    name: "Individual Taxpayer Identification Number",
    abbreviation: "ITIN",
    errorMessage: "Please provide a valid ITIN.",
  },
  [NationalIdNumberTypeIds.SSN]: {
    id: NationalIdNumberTypeIds.SSN,
    name: "Social Security Number",
    abbreviation: "SSN",
    errorMessage: "Please provide a valid SSN.",
  },
};
